export interface Product {
  id: string;
  name: string;
  price: string;
  image: string;
  link: string;
}

export interface ProductCategory {
  name: string;
  slug: string;
  link: string;
  products: Product[];
}

export const productCategories: ProductCategory[] = [
  {
    name: 'Shoes',
    slug: 'shoes',
    link: 'https://kaspreadsheet.com/category-911-Shoes.html',
    products: [
      {
        id: 'goods-136312',
        name: 'Black Canvas Combat Boots with Side Zippers',
        price: '¥678',
        image: 'https://si.geilicdn.com/open1775823299-1234478995-52da00000198bbc54c190aa0c791_620_620.jpg',
        link: 'https://kaspreadsheet.com/goods-136312.html',
      },
      {
        id: 'goods-136311',
        name: 'Louis Vuitton Archlight White Monogram Print',
        price: '¥397',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-6f9600000194e2901d1a0a239383_800_600.jpg',
        link: 'https://kaspreadsheet.com/goods-136311.html',
      },
      {
        id: 'goods-136310',
        name: 'Rick Owens Geobasket High-Top Sneaker',
        price: '¥585',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-1a000000019749d603be0a22d249_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-136310.html',
      },
      {
        id: 'goods-136309',
        name: 'Off-White Diagonal Arrow Low-Top Sneakers',
        price: '¥300',
        image: 'https://si.geilicdn.com/pcitem1513127982-3b200000019667fbebea0a21146b_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-136309.html',
      },
      {
        id: 'goods-136308',
        name: 'Nike Tiempo Legend 9 IC Soccer Shoes',
        price: '¥268',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-6f9000000194b81466ec0aa08290_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-136308.html',
      },
      {
        id: 'goods-136307',
        name: 'Louis Vuitton Archlight Star Motif',
        price: '¥528',
        image: 'https://si.geilicdn.com/pcitem1871933355-69ef00000190a56ff3d40a8133cc_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-136307.html',
      },
      {
        id: 'goods-136306',
        name: 'Louis Vuitton Trainer Low Monogram Canvas',
        price: '¥297',
        image: 'https://si.geilicdn.com/wdseller901862032983-53ff00000190603e9a530a2102c5_1170_1173.jpg',
        link: 'https://kaspreadsheet.com/goods-136306.html',
      },
      {
        id: 'goods-136305',
        name: 'Off-White Diagonal Arrow Low-Top Black-White',
        price: '¥258',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-38cd000001977cd8cc7d0a231226_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-136305.html',
      },
    ],
  },
  {
    name: 'Hoodies / Sweaters',
    slug: 'hoodies',
    link: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    products: [
      {
        id: 'goods-138084',
        name: 'OFFSETTEARS Black Hoodie with Orange Graphic',
        price: '¥186',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-6bc000000194965ed7d10a239383_1920_1920.jpg',
        link: 'https://kaspreadsheet.com/goods-138084.html',
      },
      {
        id: 'goods-137567',
        name: 'Supreme Margiela Paris Zip-Up Hoodie',
        price: '¥136',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-4ad900000199c30f90a50aa0229a_1280_1280.jpg',
        link: 'https://kaspreadsheet.com/goods-137567.html',
      },
      {
        id: 'goods-137459',
        name: 'BAPE x Inter Miami CF Camo Hoodie',
        price: '¥141',
        image: 'https://si.geilicdn.com/open1815288597-1234478995-0c480000019791690d9a0a8133b0_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-137459.html',
      },
      {
        id: 'goods-137449',
        name: 'Dior Oblique Monogram Logo Sweatshirt',
        price: '¥176',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-679b00000195474e9a2d0a8115c2_1125_1125.jpg',
        link: 'https://kaspreadsheet.com/goods-137449.html',
      },
      {
        id: 'goods-137348',
        name: 'Nike Lost Repeat Graphic Fleece Crewneck',
        price: '¥274',
        image: 'https://si.geilicdn.com/pcitem1945679661-278900000198c64832cd0a20e2c5_945_1280.jpg',
        link: 'https://kaspreadsheet.com/goods-137348.html',
      },
      {
        id: 'goods-137303',
        name: 'BOSS Embossed Logo Crewneck Sweatshirt',
        price: '¥141',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-4dc8000001977c8963190a8133b0_1024_1024.jpg',
        link: 'https://kaspreadsheet.com/goods-137303.html',
      },
      {
        id: 'goods-137105',
        name: 'Polo Ralph Lauren Cable Knit Sweater',
        price: '¥148',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-7dfe000001955822c0a80a22d249_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-137105.html',
      },
      {
        id: 'goods-137044',
        name: 'Burberry Rainbow Equestrian Knight Logo',
        price: '¥155',
        image: 'https://si.geilicdn.com/pcitem1886196013-3fe800000195989eafd90a210256_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-137044.html',
      },
    ],
  },
  {
    name: 'T-Shirts',
    slug: 't-shirts',
    link: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    products: [
      {
        id: 'goods-138192',
        name: 'Nike Dri-FIT Cotton T-Shirt 1972 Logo',
        price: '¥112',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-529a000001977c85cb740a231226_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-138192.html',
      },
      {
        id: 'goods-138188',
        name: 'Louis Vuitton x Malletier Navy T-Shirt',
        price: '¥175',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-2e0f00000196ab5b18160a8133b0_1080_1080.jpg',
        link: 'https://kaspreadsheet.com/goods-138188.html',
      },
      {
        id: 'goods-138187',
        name: 'Stüssy World Tour Polo Shirt',
        price: '¥169',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-0017000001974412c93c0a23b491_1024_1024.jpg',
        link: 'https://kaspreadsheet.com/goods-138187.html',
      },
      {
        id: 'goods-138186',
        name: 'FENDI Dragon Graphic T-Shirt',
        price: '¥109',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-3868000001955b71f6390a23b491_1080_1080.jpg',
        link: 'https://kaspreadsheet.com/goods-138186.html',
      },
      {
        id: 'goods-138185',
        name: 'Palm Angels Bear Graphic T-Shirt',
        price: '¥139',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-3d10000001952f1af3560a23b491_1000_1000.jpg',
        link: 'https://kaspreadsheet.com/goods-138185.html',
      },
      {
        id: 'goods-138183',
        name: 'Rhude Premium Cigars Logo Graphic T-Shirt',
        price: '¥98',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-214100000195c9825ed90a8133b0_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-138183.html',
      },
      {
        id: 'goods-138182',
        name: 'Valentino VLogo Embroidered Black T-Shirt',
        price: '¥150',
        image: 'https://si.geilicdn.com/open1718885333-1234478995-4cd50000019648d7af310a23b491-unadjust_475_522.png',
        link: 'https://kaspreadsheet.com/goods-138182.html',
      },
      {
        id: 'goods-138181',
        name: 'Cole Buxton Dog Logo Graphic T-Shirt',
        price: '¥124',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-096700000197974c396b0a22d249_1280_1280.jpg',
        link: 'https://kaspreadsheet.com/goods-138181.html',
      },
    ],
  },
  {
    name: 'Jackets',
    slug: 'jackets',
    link: 'https://kaspreadsheet.com/category-914-Jackets.html',
    products: [
      {
        id: 'goods-136582',
        name: 'Under Armour Storm Rain Jacket Black',
        price: '¥118',
        image: 'https://si.geilicdn.com/open1767724244-1234478995-69310000019715c9e1c30a8133b0_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-136582.html',
      },
      {
        id: 'goods-136303',
        name: 'Louis Vuitton Monogram Windbreaker Jacket',
        price: '¥472',
        image: 'https://si.geilicdn.com/open1742170557-1234478995-7b50000001977caa02d80a22d249_1276_1702.jpg',
        link: 'https://kaspreadsheet.com/goods-136303.html',
      },
      {
        id: 'goods-136284',
        name: 'A BATHING APE Denim Jacket Cross Motif',
        price: '¥288',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-7e94000001943acc82ee0a239383_1000_1000.jpg',
        link: 'https://kaspreadsheet.com/goods-136284.html',
      },
      {
        id: 'goods-136276',
        name: 'Zara Butterfly Logo Fleece Track Jacket',
        price: '¥190',
        image: 'https://si.geilicdn.com/open1675136579-1234478995-66aa00000198a68a28e10a231226_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-136276.html',
      },
      {
        id: 'goods-136203',
        name: 'Canada Goose Crofton Vest Black Quilted',
        price: '¥329',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-0d9d00000194c30b210a0a210559_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-136203.html',
      },
      {
        id: 'goods-136189',
        name: 'Louis Vuitton Monogram Quilted Puffer',
        price: '¥260',
        image: 'https://si.geilicdn.com/pcitem901971869584-335c00000199bdf837270a23111a_1280_1280.jpg',
        link: 'https://kaspreadsheet.com/goods-136189.html',
      },
      {
        id: 'goods-136181',
        name: 'Canada Goose Youth Expedition Parka',
        price: '¥590',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-4c51000001952f1d25bb0aa0834c_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-136181.html',
      },
      {
        id: 'goods-135968',
        name: 'Prada RDAPA Logo Tape Track Jacket',
        price: '¥517',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-3e840000019769c4fcd30a8115c2_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-135968.html',
      },
    ],
  },
  {
    name: 'Pants / Shorts',
    slug: 'pants',
    link: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    products: [
      {
        id: 'goods-137495',
        name: 'OceanView Cruise Logo Shorts Pink',
        price: '¥94',
        image: 'https://si.geilicdn.com/open1877254536-1234478995-1a74000001972b942b510a8115c2_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-137495.html',
      },
      {
        id: 'goods-137207',
        name: 'Prada Re-Nylon Triangle Logo Swim Shorts',
        price: '¥153',
        image: 'https://si.geilicdn.com/open1691309225-1234478995-51a700000196d91ec6a60aa0834c_2560_2560.jpg',
        link: 'https://kaspreadsheet.com/goods-137207.html',
      },
      {
        id: 'goods-136530',
        name: '1230 Holy Holy Graphic Shorts Black',
        price: '¥142',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-1d6c00000197494076c30a22d249-unadjust_900_900.png',
        link: 'https://kaspreadsheet.com/goods-136530.html',
      },
      {
        id: 'goods-136300',
        name: 'Balenciaga Rainbow Logo Washed Jeans',
        price: '¥280',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-78d400000196c048651b0a231226_1442_1922.jpg',
        link: 'https://kaspreadsheet.com/goods-136300.html',
      },
      {
        id: 'goods-136286',
        name: 'DÉPT de la GALERIE Paint-Splatter Pants',
        price: '¥169',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-606c00000193dded32260a22d234_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-136286.html',
      },
      {
        id: 'goods-136266',
        name: 'Gucci GG Monogram Print Drawstring Shorts',
        price: '¥110',
        image: 'https://si.geilicdn.com/open1718885333-1234478995-71b10000019648fa027e0a231226_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-136266.html',
      },
      {
        id: 'goods-136257',
        name: 'Nike Run Air Force 1 Black Jogger Pants',
        price: '¥120',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-70e300000196c03ef9eb0a231226_1440_1920.jpg',
        link: 'https://kaspreadsheet.com/goods-136257.html',
      },
      {
        id: 'goods-136249',
        name: 'Moncler Diagonal Stripe Shorts White',
        price: '¥199',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-0e490000019558486bc90a8115c2_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-136249.html',
      },
    ],
  },
  {
    name: 'Headwear',
    slug: 'headwear',
    link: 'https://kaspreadsheet.com/category-916-Headwear.html',
    products: [
      {
        id: 'goods-133388',
        name: 'New Era 59FIFTY MLB Dodgers Cap',
        price: '¥170',
        image: 'https://si.geilicdn.com/open1821611651-1234478995-7ca3000001984ac153c70aa043f9_1137_1137.jpg',
        link: 'https://kaspreadsheet.com/goods-133388.html',
      },
      {
        id: 'goods-133383',
        name: 'Burberry Logo Knit Beanie Hat',
        price: '¥112',
        image: 'https://si.geilicdn.com/open1815288597-1234478995-73f50000019767422ae30a22d249_1074_1074.jpg',
        link: 'https://kaspreadsheet.com/goods-133383.html',
      },
      {
        id: 'goods-133370',
        name: 'alo Reflective Visor with Logo',
        price: '¥81',
        image: 'https://si.geilicdn.com/open1767724244-1234478995-31420000019672781d5b0a8133b0_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-133370.html',
      },
      {
        id: 'goods-133369',
        name: 'Gucci GG Monogram Beige Mesh Cap',
        price: '¥110',
        image: 'https://si.geilicdn.com/open1811769437-1234478995-544b0000019764bb73ad0aa0c79f-unadjust_886_849.png',
        link: 'https://kaspreadsheet.com/goods-133369.html',
      },
      {
        id: 'goods-133362',
        name: 'SYNER Graffiti Knit Beanie Hat',
        price: '¥81',
        image: 'https://si.geilicdn.com/open1612884413-1234478995-1c6c000001977e57fb830a231226_1280_1280.jpg',
        link: 'https://kaspreadsheet.com/goods-133362.html',
      },
      {
        id: 'goods-133349',
        name: 'Dior Oblique Monogram Baseball Cap',
        price: '¥99',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-6e3400000195457be2de0a231226_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-133349.html',
      },
      {
        id: 'goods-133343',
        name: 'New Era 59FIFTY Dodgers Floral Cap',
        price: '¥99',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-4bc600000194e27f91c20a232357-unadjust_900_900.png',
        link: 'https://kaspreadsheet.com/goods-133343.html',
      },
      {
        id: 'goods-133342',
        name: 'Stone Island Compass Bucket Hat',
        price: '¥58',
        image: 'https://si.geilicdn.com/pcitem901908522262-348800000195413652c40a2395d6-unadjust_500_500.gif',
        link: 'https://kaspreadsheet.com/goods-133342.html',
      },
    ],
  },
  {
    name: 'Sets',
    slug: 'sets',
    link: 'https://kaspreadsheet.com/category-917-Sets.html',
    products: [
      {
        id: 'goods-138191',
        name: 'Nike Dri-FIT Academy Soccer Jersey Set',
        price: '¥144',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-15a700000197493e80b70a8133b0_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-138191.html',
      },
      {
        id: 'goods-138184',
        name: 'Stone Island Compass Logo Short Set',
        price: '¥175',
        image: 'https://si.geilicdn.com/open1742154973-1234478995-22160000019769f3aee70aa0c79f_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-138184.html',
      },
      {
        id: 'goods-138178',
        name: 'Gucci GG Monogram Shirt & Shorts Set',
        price: '¥154',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-44260000019779312b2c0aa0c79f_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-138178.html',
      },
      {
        id: 'goods-138161',
        name: 'Real Madrid Training Kit Jersey Set',
        price: '¥139',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-0675000001973f6663200a23b4de_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-138161.html',
      },
      {
        id: 'goods-138159',
        name: 'BOSS Black Track Suit with Logo',
        price: '¥177',
        image: 'https://si.geilicdn.com/pcitem1944626857-760e0000019773c369f50a239846_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-138159.html',
      },
      {
        id: 'goods-138154',
        name: 'ALLSTAR Flame Graphic T-Shirt Set',
        price: '¥315',
        image: 'https://si.geilicdn.com/open1824078381-1234478995-3ab900000196a5bc0b000a8115c2_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-138154.html',
      },
      {
        id: 'goods-138153',
        name: 'Stone Island Compass Logo Pink Set',
        price: '¥270',
        image: 'https://si.geilicdn.com/open1811769437-1234478995-0fa9000001973f4d55700a23b4de_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-138153.html',
      },
      {
        id: 'goods-138135',
        name: 'Versace Logo Print Shirt & Shorts Set',
        price: '¥125',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-53280000019572c0d6ca0a8115c2_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-138135.html',
      },
    ],
  },
  {
    name: 'Underwear / Underpants',
    slug: 'underwear',
    link: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    products: [
      {
        id: 'goods-136447',
        name: 'Louis Vuitton Monogram Gradient Bodysuit',
        price: '¥159',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-416b0000019572963ee90aa08290_1440_1920.jpg',
        link: 'https://kaspreadsheet.com/goods-136447.html',
      },
      {
        id: 'goods-136200',
        name: 'lululemon Align Soft High-Waisted',
        price: '¥95',
        image: 'https://si.geilicdn.com/open1718885333-1234478995-3e8000000197a64cbaec0a23b491_1080_1441.jpg',
        link: 'https://kaspreadsheet.com/goods-136200.html',
      },
      {
        id: 'goods-136037',
        name: 'Calvin Klein Cotton Boxer Briefs',
        price: '¥29',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-417800000193c49caaea0a210559_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-136037.html',
      },
      {
        id: 'goods-135612',
        name: 'LACOSTE Classic Logo Waistband 3-Pack',
        price: '¥99',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-659b00000193ce9623d00a8133b5_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-135612.html',
      },
      {
        id: 'goods-135596',
        name: 'PSD SpongeBob SquarePants Underwear',
        price: '¥45',
        image: 'https://si.geilicdn.com/pcitem901950853318-589000000196dd1ae0cf0a81347d_4800_4800.jpg',
        link: 'https://kaspreadsheet.com/goods-135596.html',
      },
      {
        id: 'goods-135593',
        name: 'Calvin Klein Cotton Boxer Briefs',
        price: '¥108',
        image: 'https://si.geilicdn.com/open1783746229-1234478995-7eae000001966daf5aca0a22d249_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-135593.html',
      },
      {
        id: 'goods-135575',
        name: 'Supreme Boxer Briefs Cotton',
        price: '¥30',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-7ffd000001974a632f450a8133b0_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-135575.html',
      },
      {
        id: 'goods-135566',
        name: 'Hermès Logo Waistband Boxer Briefs',
        price: '¥34',
        image: 'https://si.geilicdn.com/open1858585309-1234478995-2360000001977d2fc4a40a8133b0_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-135566.html',
      },
    ],
  },
  {
    name: 'Jersey',
    slug: 'jersey',
    link: 'https://kaspreadsheet.com/category-919-Jersey.html',
    products: [
      {
        id: 'goods-138190',
        name: 'Paris Saint-Germain 2023 Champions Jersey',
        price: '¥106',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-030c000001973f6540060aa0834c_942_983.jpg',
        link: 'https://kaspreadsheet.com/goods-138190.html',
      },
      {
        id: 'goods-138180',
        name: 'PSG Qatar Airways Training Jersey',
        price: '¥165',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-7a2000000195bfc0adac0a8115c2_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-138180.html',
      },
      {
        id: 'goods-138175',
        name: 'FC Barcelona Lamine Yamal 19 Away',
        price: '¥128',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-025700000195cf19315b0a23b4de_450_450.jpg',
        link: 'https://kaspreadsheet.com/goods-138175.html',
      },
      {
        id: 'goods-138164',
        name: 'Supreme 30th Anniversary Football Jersey',
        price: '¥331',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-1c2d000001974942961f0a23b4de_800_762.jpg',
        link: 'https://kaspreadsheet.com/goods-138164.html',
      },
      {
        id: 'goods-138155',
        name: 'Palmeiras 2023 Home Jersey Yellow',
        price: '¥63',
        image: 'https://si.geilicdn.com/open1675274933-1234478995-19cc000001967ca93aab0a23b491_1202_1202.jpg',
        link: 'https://kaspreadsheet.com/goods-138155.html',
      },
      {
        id: 'goods-138150',
        name: 'Real Madrid 2000-01 Home Jersey White',
        price: '¥118',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-66a800000195bfccb6a40a231226_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-138150.html',
      },
      {
        id: 'goods-138148',
        name: 'Adidas x Flame Silhouette Football Jersey',
        price: '¥99',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-279000000195c9a5168f0aa08290_941_963.jpg',
        link: 'https://kaspreadsheet.com/goods-138148.html',
      },
      {
        id: 'goods-138139',
        name: 'PSG 2023-24 Third Jersey Black',
        price: '¥142',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-7bf5000001975f2f34a10a23b4de_1107_1107.jpg',
        link: 'https://kaspreadsheet.com/goods-138139.html',
      },
    ],
  },
  {
    name: 'Accessories',
    slug: 'accessories',
    link: 'https://kaspreadsheet.com/category-920-Accessories.html',
    products: [
      {
        id: 'goods-137556',
        name: 'Cartier Santos Dumont Square Watch',
        price: '¥599',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-10690000019673cee0e70aa0834c_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-137556.html',
      },
      {
        id: 'goods-137382',
        name: 'Louis Vuitton Monogram World Tour Bracelet',
        price: '¥165',
        image: 'https://si.geilicdn.com/open1767724244-1234478995-423700000197160db1620a8133b0_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-137382.html',
      },
      {
        id: 'goods-135965',
        name: 'Apple Watch Series 6 Black Aluminum',
        price: '¥170',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-5ea900000193d8cce9290a232357_1024_1024.jpg',
        link: 'https://kaspreadsheet.com/goods-135965.html',
      },
      {
        id: 'goods-135384',
        name: 'Apple Watch Series 9 GPS + Cellular',
        price: '¥288',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-07640000019673be92750a8115c2_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-135384.html',
      },
      {
        id: 'goods-135380',
        name: 'Apple Watch Ultra 2 Purple Woven Band',
        price: '¥399',
        image: 'https://si.geilicdn.com/open1776978413-1234478995-0d200000019740bb8f220a8115c2_1179_1179.jpg',
        link: 'https://kaspreadsheet.com/goods-135380.html',
      },
      {
        id: 'goods-134538',
        name: 'Apple Watch Ultra 2 Desert Tan Alpine',
        price: '¥275',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-3047000001927ca712ba0aa08290_1290_1290.jpg',
        link: 'https://kaspreadsheet.com/goods-134538.html',
      },
      {
        id: 'goods-133945',
        name: 'Casio Baby-G G-Lide BGA-210 Digital',
        price: '¥150',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-4a5a000001937c768dab0a210298_1080_810.jpg',
        link: 'https://kaspreadsheet.com/goods-133945.html',
      },
      {
        id: 'goods-133944',
        name: 'Apple Watch Series 7 Black Aluminum',
        price: '¥258',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-0fe50000019673cd17830aa0834c_750_750.jpg',
        link: 'https://kaspreadsheet.com/goods-133944.html',
      },
    ],
  },
  {
    name: 'Bags',
    slug: 'bags',
    link: 'https://kaspreadsheet.com/category-921-Bags.html',
    products: [
      {
        id: 'goods-135418',
        name: 'SMINDUS TRUO Black Mesh Golf Towel',
        price: '¥261',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-44f8000001976cf1b5d50a8115c2-unadjust_500_500.gif',
        link: 'https://kaspreadsheet.com/goods-135418.html',
      },
      {
        id: 'goods-134959',
        name: 'Prada Milano Woven Mini Tote Bag',
        price: '¥335',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-5c300000019572da6a310a8115c2_1442_1922.jpg',
        link: 'https://kaspreadsheet.com/goods-134959.html',
      },
      {
        id: 'goods-133386',
        name: 'Goyard Saint Louis Mini Crossbody Bag',
        price: '¥165',
        image: 'https://si.geilicdn.com/pcitem901900035971-74aa000001938a89828e0a23041a_1000_1333.jpg',
        link: 'https://kaspreadsheet.com/goods-133386.html',
      },
      {
        id: 'goods-133276',
        name: 'Louis Vuitton Monogram Canvas Tote',
        price: '¥139',
        image: 'https://si.geilicdn.com/pcitem901891552790-1ba50000019390628c620a2396f4_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-133276.html',
      },
      {
        id: 'goods-133272',
        name: 'Chanel 25P Kelly Mini Bag Lambskin',
        price: '¥374',
        image: 'https://si.geilicdn.com/open1823866485-1234478995-534900000195a49cb72e0a8133b0_1080_1439.jpg',
        link: 'https://kaspreadsheet.com/goods-133272.html',
      },
      {
        id: 'goods-133264',
        name: 'Chanel White Quilted Double Flap Bucket',
        price: '¥199',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-74c600000195475287920a23b4de_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-133264.html',
      },
      {
        id: 'goods-133244',
        name: 'Goyard Saint-Louis PM Tote Green',
        price: '¥138',
        image: 'https://si.geilicdn.com/open1757144309-1234478995-5bcc0000019698dce2c40a22d249_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-133244.html',
      },
      {
        id: 'goods-133226',
        name: 'Louis Vuitton Allin BB Monogram Bucket',
        price: '¥546',
        image: 'https://si.geilicdn.com/ch1931865500-1a9400000197741d80650a230115_1920_1440.jpg',
        link: 'https://kaspreadsheet.com/goods-133226.html',
      },
    ],
  },
  {
    name: 'Belts',
    slug: 'belts',
    link: 'https://kaspreadsheet.com/category-922-Belts.html',
    products: [
      {
        id: 'goods-133199',
        name: 'Fendi FF Logo Belt with Gold Buckle',
        price: '¥146',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-1bb200000197910d6d570a22d249_1000_1000.jpg',
        link: 'https://kaspreadsheet.com/goods-133199.html',
      },
      {
        id: 'goods-133145',
        name: 'AMIRI Logo Buckle Belt White Leather',
        price: '¥95',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-482a000001952f0b7ef60aa0834c-unadjust_936_925.png',
        link: 'https://kaspreadsheet.com/goods-133145.html',
      },
      {
        id: 'goods-133079',
        name: 'Hermès H-Pin Buckle Leather Belt',
        price: '¥142',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-400500000195c492a20b0a23b4de_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-133079.html',
      },
      {
        id: 'goods-133074',
        name: 'Dior Oblique Pattern Belt with CD Buckle',
        price: '¥128',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-0eb600000194e1e8290b0a232357_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-133074.html',
      },
      {
        id: 'goods-133059',
        name: 'Valentino Garavani VLogo Belt',
        price: '¥68',
        image: 'https://si.geilicdn.com/open1858585309-1234478995-07e4000001977db6177b0a8133b0_2560_3413.jpg',
        link: 'https://kaspreadsheet.com/goods-133059.html',
      },
      {
        id: 'goods-133045',
        name: 'Burberry Black Check-Print Leather Belt',
        price: '¥85',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-3d6100000193b49f9e400a210298_1276_1702.jpg',
        link: 'https://kaspreadsheet.com/goods-133045.html',
      },
      {
        id: 'goods-133023',
        name: 'Fendi FF Logo Belt Black Leather',
        price: '¥139',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-191100000195c48b97cd0a231226-unadjust_500_375.gif',
        link: 'https://kaspreadsheet.com/goods-133023.html',
      },
      {
        id: 'goods-133021',
        name: 'Cartelostyle Geometric Pattern Leather Belt',
        price: '¥76',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-58e500000193d93330f30a210559-unadjust_783_842.png',
        link: 'https://kaspreadsheet.com/goods-133021.html',
      },
    ],
  },
  {
    name: 'Perfumes',
    slug: 'perfumes',
    link: 'https://kaspreadsheet.com/category-923-Perfumes.html',
    products: [
      {
        id: 'goods-138044',
        name: 'Delina 75ml Pink Perfume with Tassel',
        price: '¥148',
        image: 'https://si.geilicdn.com/pcitem1945403796-045400000196c304bc950a239846_1199_1199.jpg',
        link: 'https://kaspreadsheet.com/goods-138044.html',
      },
      {
        id: 'goods-133255',
        name: 'Gucci Bloom Floral 5-Piece Mini Set',
        price: '¥130',
        image: 'https://si.geilicdn.com/open1742154973-1234478995-508b00000197a7e361940aa0c791_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-133255.html',
      },
      {
        id: 'goods-133248',
        name: 'Gucci Bloom Floral Mini Perfume Gift Box',
        price: '¥109',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-121600000194c3615f810a22d234_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-133248.html',
      },
      {
        id: 'goods-133247',
        name: 'YSL La Nuit de L\'Homme Eau de Parfum',
        price: '¥108',
        image: 'https://si.geilicdn.com/open1823866485-1234478995-03e300000197841b99f20a231226_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-133247.html',
      },
      {
        id: 'goods-133207',
        name: 'Chanel Chance Eau Tendre Pink Bottle',
        price: '¥108',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-0ef200000194882a14e00a232357_1200_1200.jpg',
        link: 'https://kaspreadsheet.com/goods-133207.html',
      },
      {
        id: 'goods-133204',
        name: 'Harrods Exclusive Oud Perfume Gold Bottle',
        price: '¥159',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-6a8d00000196f49bdc7b0a231226_1280_1280.jpg',
        link: 'https://kaspreadsheet.com/goods-133204.html',
      },
      {
        id: 'goods-133051',
        name: 'MCM Visetos Mini Bag Perfume Bottle',
        price: '¥324',
        image: 'https://si.geilicdn.com/pcitem1968774131-48c200000197ede4c4dd0a23037f_1080_1080.jpg',
        link: 'https://kaspreadsheet.com/goods-133051.html',
      },
      {
        id: 'goods-133038',
        name: 'Gucci Bloom Floral Mini 5-Piece Gift Set',
        price: '¥141',
        image: 'https://si.geilicdn.com/open1742154973-1234478995-508b00000197a7e361940aa0c791_800_800.jpg',
        link: 'https://kaspreadsheet.com/goods-133038.html',
      },
    ],
  },
  {
    name: 'Other Stuff',
    slug: 'other',
    link: 'https://kaspreadsheet.com/category-924-Other+Stuff.html',
    products: [],
  },
];